<template>
  <div>
    <dialog class="myd" id="dialog">
      <div>Payment succeeded.Thank You!</div>
      <div>The invoice will be sent by email soon</div>
      <div v-show="new_client_key">
        <div>Your 64-digit payment code [ Please keep it in a safe place ]</div>
        <p><input type="text"  :placeholder="new_client_key" disabled/></p>
      </div>
      <button id="closeDialog">Close</button> &nbsp;
      <button id="copyDialog" v-show="new_client_key" @click="copyClipboard">Copy</button>
    </dialog>
  </div>
  <div class="stripe-container">
    <div class="acenter">
            <span style="margin-left: 5px">
                {{ paymentLines[0] }}
                <a href="https://stripe.com/en-ro"  target="_blank" style="font-size: 20px;color: lightpink;">
                    {{ paymentLines[1] }}
                </a>
              <span v-show="testFlag.length>0" class="testflag">{{testFlag}}</span>
              <!--<span v-show="isDev" @click="testRegistration" style="padding: 10px;background-color: #fa755a;font-size: 20px;cursor:pointer;"> Test Registration</span>-->
            </span>
          <br><br>
          <span class="icon-container">
            <img src="../assets/stripe-badge-grey.png" width="60%" height="60%">
          </span>
        </div>
    <div class="col-75">
            <form  method="post"  @submit.prevent="submitBuyerInfo"  id="payment-form">
                <div class="row">
                  <div class="col-25">
                    <label for="entity" class="required">{{paymentLines[2]}}</label> &nbsp;
                    <button class="clear"  @click="resetName">
                      30/{{entity.name.length}}
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                    <input id="entity" name="entity" type="text" :placeholder="paymentLines[3]" v-model="entity.name" @keyup="checkEntity" required maxlength="30">
                    </div>
                  <div class="col-25">
                    <label for="address" class="required">{{ paymentLines[5] }}</label>
                    <button class="clear"  @click="resetAddress">
                      40/{{entity.address.length}}
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                    <input id="address" name="entity" type="text" :placeholder="paymentLines[6]" v-model="entity.address"  @keyup="checkEntity" required maxlength="40">
                  </div>
                </div>
                <div class="row">
                  <div v-show="b2B()" class="col-25">
                    <label for="regno" class="required">{{ paymentLines[4] }}</label>
                    <button class="clear" @click="resetRegNo">
                      20/{{entity.regno.length}}
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                    <input  id="regno" name="regno" type="business" placeholder="e.g J22/842/2024" v-model="entity.regno" @keyup="checkEntity" required maxlength="20">
                  </div>
                  <div v-show="b2B()" class="col-25">
                    <label for="vatid" class="required" >{{ paymentLines[7] }}</label>
                    <button class="clear"  @click="resetVAT">
                      20/{{entity.vatid.length}}
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                    <input id="vatid" name="vatid" type="business" placeholder="e.g RO12345678" v-model="entity.vatid" @keyup="checkEntity" required maxlength="20"/>
                    </div>
                </div>
                <div class="row">
                  <div class="col-25">
                    <label for="emailconfirm" class="required">{{ paymentLines[8] }}</label> &nbsp;
                    <button class="clear"  @click="resetEmail">
                      30/{{entity.email.length}}
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                    <input id="emailconfirm" name="email" type="email" placeholder="name@server.domain" v-model="entity.email" @keyup="checkEntity" required maxlength="30">
                    </div>
                  <div class="col-25">
                    <label for="months"><span style="font-size: 12px;margin-right: 5px;font-weight: bold">{{ paymentLines[9] }}</span></label>&nbsp;&nbsp;
                    <button class="clear"  @click="resetMonths">
                      12/{{nmonths}}
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                    <input :disabled="isMonthly()" type="number" id="months"  min="1" max="12" v-model="nmonths"  @change="checkEntity" @keyup="checkEntity">
                    <span class="valability">
                      {{valability}}
                    </span>
                    <i class="fa fa-calendar-check-o" style="float: right;margin-right: 10px"></i>
                  </div>
                </div>
                <label for="card-element">
                </label>
                <br>
              <div class="row">
                <div class="col-25">
                  <div id="card-element">
                    <!-- A Stripe Element will be inserted here. -->
                  </div>
                  <!-- Used to display form errors. -->
                  <div id="card-errors" role="alert"></div>
                  <div class="bankmsg">
                    {{paymentLines[11]}}
                  </div>
                </div>
                <div class="col-25">
                  <label for="currency" class="required">{{ paymentLines[10] }}</label>
                  <select id="currency" v-model="entity.currency">
                    <option value="eur">EURO</option>
                    <option value="usd">USD</option>
                    <option value="cny">YUAN</option>
                  </select>
                </div>
              </div>
                <br>
                <hr>
                <div class="col-50">
                  <div v-if="!payOn">
                    <button :disabled="payBtnStatus" class="btn" id="paybtn">
                      {{ paymentLines[12] }}
                        <span>
                            {{price}}
                        </span>&nbsp;
                      <i v-show="isEuro" class="fa fa-eur" aria-hidden="true"></i>
                      <i v-show="isUsd" class="fa fa-usd" aria-hidden="true"></i>
                      <i v-show="isYen" class="fa fa-jpy" aria-hidden="true"></i>
                    </button>
                    <button class="btncancel" @click="cancelpayment()">{{ paymentLines[13] }}</button>
                  </div>
                  <div v-else>
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size: 18px"></i>
                    <span style="color: white">Payment ongoing</span>
                  </div>
                </div>
              <div>
                <span style="font-size: 13px;float:left">* {{ paymentLines[14] }} </span>
              </div>
            </form>
        </div>
    <br>
    <div class="privacymsg">
      <span style="color: salmon">
        <i class="fa fa-shield" aria-hidden="true" ></i> {{ paymentLines[15] }}
      </span>
      {{ paymentLines[16] }}
    </div>
  </div>
</template>
<script>
    import {getBaseURL} from "../../url_endpoints";
    import {getPayFormFields} from "@/translate";
    import {generateHID, get_UPAYS_auth, get_UPAYS_LIVE, get_UPAYS_TEST} from "@/components/hid";
    import {salesToAnalytics} from "salesstats";
    export default {
      name: 'Payment',
      data() {
            return {
              new_client_key:'12345678901234567890123456789012345678901234567890',
              entity : {
                email: '',
                name:'',
                address:'',
                vatid:'',
                regno:'',
                api:null,
                currency:'usd',
              },
              stripe: '',
              elements: '',
              entityFlag: false,
              stripeAPI:null,
              card: null,
              nmonths:1,
              stripeClientTokenId:null,
              price_unit:19,
              access_key:null,
              client_config:{},
              paymentLines:[
                  'Created by','UpayS with Stripe','Name','Enter Name','Registration Number','Address','Billing Address',
                  'VAT Id','E-mail','Months','Currency',
                  'By providing your Card Number and confirming this payment you are authorizing STRIPE - the payment service provider to send instructions to your bank to debit your account.',
                  'Pay','Cancel','Invoice Required fields','Privacy Policy','Input Data are used for Your Invoice on Stripe Server'
              ],
              lang:0, // 0 eng , 1 chn
              customer_key:false,
              payon:false,
              testFlag:'TEST mode',
              authAWE: {
                username:'aff_programs',
                password:'mee_and_you_is_',
              }
            }
        },
      created() {
          this.emitter.on('change_language', (evt) => {
            //console.log(evt.eventContent)
            if(evt.eventContent === '1') {
              this.paymentLines = getPayFormFields(1)
            }else {
              this.paymentLines = getPayFormFields(0)
            }
          })
        this.emitter.emit('paypage', {'eventContent': '1'})
        //console.log(window.location.href)
        /* hide URL in order to protect client access key & stripe api*/
        history.pushState("/", "", "/upays")
        /* make back button  to home page - like cancel*/
        window.addEventListener('popstate', () =>{
          this.cancelpayment()
        })
        /* reload page - stay in page */
        window.addEventListener('beforeunload', () =>{
          //console.log('reload page by button BEFORE UNLOAD')
        })
      },
      mounted() {
        /* customize information for each client/app */
        this.access_key = this.$route.params.key
        this.price_unit = this.$route.params.unit
        this.entity.api = this.$route.params.stripe
        // set TEST flag
        if(this.entity.api.includes('_test_')){
          this.testFlag = 'TEST mode'
        }else {
          this.testFlag = ''
        }
        this.lang = this.$route.params.lang
        const ckey = localStorage.getItem('create_code')
        this.customer_key = !ckey ? false : ckey === 'true'
        /* get config data from BE server*/
        const config = JSON.parse(localStorage.getItem('pconfig'))
        this.client_config = !config ?  {b2b:0,monthly:0,weblink:'/',csc:false} : Object.assign({},config)
        this.initPaymentBusinessClient()
        this.paymentLines = getPayFormFields(Number.parseInt(this.lang))
        /* test dialog */
        //this.createDialogMessage()
        },
        computed: {
          isDev() {
            return process.env.NODE_ENV === 'development'
          },
          isEuro() {
            return this.entity.currency ==='eur'
          },
          isUsd() {
            return this.entity.currency ==='usd'
          },
          isYen(){
            return this.entity.currency ==='cny'
          },
          payBtnStatus() {
            return !this.entityFlag
          },
          price() {
            return this.price_unit*this.nmonths
          },
          valability() {
            let now = new Date()
                /*
                let safaribw = false
                if(this.$store.getters.getExtendActive) {
                    const stime = this.$store.getters.getCurrentBusiness.subscription_time
                    const num_months = this.$store.getters.getCurrentBusiness.subscription_months
                    now = new Date(stime)
                    if(isNaN(now)) {
                        // SAFARI case
                        safaribw = true
                        const darr = stime.split('-')
                        now = new Date(darr[0],darr[1],darr[2])
                    }
                    now.setMonth(now.getMonth() + num_months);
                }*/
            now.setMonth((now.getMonth()+1) + this.nmonths);
                //return safaribw ? now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate() : now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate()
            return now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate()
          },
          payOn(){
            return this.payon;
          }
        },
        methods: {
          testAnalytics(value,currency) {
            //console.log('Currency: '+currency +' Value: '+value)
            const AWE_PLATFORM_URL =  'https://awe-server-279e3d1a5920.herokuapp.com'
            const AWE_LOCAL = 'http://localhost:3006'
            const serverURL = (process.env.NODE_ENV === 'production') ? AWE_PLATFORM_URL : AWE_LOCAL
            const endPoint = '/wizard/sale'
            salesToAnalytics({sale_value:value,currency:currency},serverURL,endPoint,this.authAWE,true)
          },
          resetName() {
            this.entity.name = ''
          },
          resetAddress() {
            this.entity.address = ''
          },
          resetVAT() {
            this.entity.vatid = ''
          },
          resetRegNo() {
            this.entity.regno = ''
          },
          resetEmail() {
            this.entity.email = ''
          },
          resetMonths() {
            this.nmonths =1
          },
          createDialogMessage() {
            /* define modal that shows payment result */
            const dialog = document.getElementById('dialog')
            const closeButtonDialog = document.getElementById('closeDialog')
            // show dialog
            dialog.showModal()
            // "Close" button closes the dialog
            closeButtonDialog.addEventListener("click", () => {
              dialog.close()
              this.continueToWebSite()
            })
          },
          copyClipboard(){
            let x = this.new_client_key
            const textSpinning = [
              { transform: "rotate(0) scale(1)" },
              { transform: "rotate(360deg) scale(0)" },
            ];
            const textTiming = {
              duration: 2000,
              iterations: 1,
            };
            navigator.clipboard.writeText(`${x}`).then( () => {
              const copyBtn = document.getElementById('copyDialog')
              //copyBtn.setAttribute('backgroundColor','lightpink')
              copyBtn.animate(textSpinning, textTiming);
            })
          },
          cleanPayHandler() {
            localStorage.removeItem('invoice_data')
            localStorage.removeItem('card_data')
          },
          cleanBrowserCache(){
            localStorage.removeItem('pconfig')
            localStorage.removeItem('create_code')
            /* clear client code generator inputs */
            localStorage.removeItem('tid')
            localStorage.removeItem('aid')
          },
          getBusinessID() {
            const local_tid = localStorage.getItem('tid')
            const local_aid = localStorage.getItem('aid')
            return  !local_aid ? 't'+local_tid : 'a'+local_aid
          },
          updatePaymentStats(){
            let stat = {
              key:localStorage.getItem('payment_key'),
              amount:this.price_unit*this.nmonths,
              tk:'19bd7df4f45da9d7a12bde4112cf25db97db6d0qf6b98f130b64cfe9a6a2b12e',
              //id:!localStorage.getItem('tid') ? localStorage.getItem('aid') : localStorage.getItem('tid'),
            }
            localStorage.removeItem('payment_key')
            const baseURL = getBaseURL()
            fetch(baseURL+"/admin/paystat", {
              method: 'POST',
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              },
              redirect: 'follow',
              referrerPolicy: 'no-referrer',
              body: JSON.stringify(stat)
            }).then(response => {
              return response.json()
            }).then( rsp => {
              if(rsp['stat']) {
                //console.log('Update stats successful!')
              }else{
                //console.log('Update stats failed!')
              }
            }).catch( () => {
              //console.log('Error when POST stats: ')
              //throw new Error('Update payment stats failed! - '+err.message)
            })

          },
          msgPaymentCompleted(){
            /* generates customer Key if was requested */
            if(this.customer_key){
              let keymsg = Date.now()
              keymsg = keymsg + this.entity.email
              const key = generateHID(keymsg.toString())
              const bid = this.getBusinessID()
              /* NEW DESIGN IMPLEMENTED 0.3.12.2025 */
              this.new_client_key = key
              /*
              prompt('Payment succeeded.Thank You! ' +
                  'The invoice will be sent by email soon.' +
                  'Your 64-digit payment code:\n',key)
               */
              /* define modal that shows payment result */
              //this.createDialogMessage()
              /* generate customer key for this business ID cause payment completed  - GOLD business */
              const baseURL = getBaseURL()
              let customer = {
                bid:bid,
                code:key,
                tk:'79bd7df4f45da9d7a12bde4112cf25db97db6d0qf6b98f130b64cfe9a6a2b12e',
              }
              fetch(baseURL+"/clients/customer", {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(customer)
              }).then(response => {
                return response.json()
              }).then( rsp => {
                if(rsp['add']) {
                  //console.log('Your Payment Code was validated!')
                }else{
                  //console.log('Error validation payment code\n Please contact support!')
                }
                this.createDialogMessage()
                //this.continueToWebSite()
              }).catch( () => {
                //throw new Error('Insert payment code failed : - '+err.message)
                //console.log('Error request to save customer code')
                this.continueToWebSite()
              })
            }else {
              //alert('Payment succeeded.\nThank You for your order!\nInvoice will be generated and send it soon...')
              this.createDialogMessage()
              //this.continueToWebSite()
            }
          },
          b2B() {
            return this.client_config.b2b === 0
          },
          isMonthly(){
            return this.client_config.monthly !== 0
          },
          continueToWebSite() {
            //console.log('continueToWebSite: ',this.client_config.weblink)
            if(this.client_config.weblink === '/') {
              this.emitter.emit('payment', {'eventContent': 'ok'})
              this.entityFlag = true
              this.payon = false
              //this.$router.push(this.client_config.weblink)
            }else {
              window.location.href = 'https://'+this.client_config.weblink;
            }
          },
          cancelpayment() {
            //console.log('cancel payment')
            // go to landing page set by the client
            this.cleanPayHandler()
            this.cleanBrowserCache()
            this.emitter.emit('paypage', {'eventContent': '0'})
            if(this.client_config.weblink === '/') {
              this.$router.push(this.client_config.weblink)
            }else {
              window.location.href = 'https://'+this.client_config.weblink;
            }
          },
          configClientStripe(){
            this.stripe = window.Stripe(this.stripeAPI)
            this.elements = this.stripe.elements()
            this.card = this.elements.create('card')
            this.card.mount('#card-element')
            // Handle real-time validation errors from the card Element.
            this.card.addEventListener('change', function(event) {
              let displayError = document.getElementById('card-errors')
              let btnPlaystatus = document.getElementById('paybtn')
              if(event.complete){
                //alert("Complete data")
                const idata = localStorage.getItem('invoice_data')
                btnPlaystatus.disabled = !idata
                localStorage.setItem('card_data','1')
              } else{
                btnPlaystatus.disabled = true
                localStorage.removeItem('card_data')
                if (event.error) {
                  displayError.textContent = event.error.message
                }else{
                  displayError.textContent = ''
                }
              }
            })
          },
          initPaymentBusinessClient() {
            this.stripeAPI = process.env.NODE_ENV === 'production' ? get_UPAYS_LIVE() :get_UPAYS_TEST()
            this.configClientStripe()
          },
          checkEmailFormat(){
            //console.log('Check email format')
            if(!this.entity.email) {
              //console.log('Check email null')
              return false
            }else {
              //console.log('Check email not null')
              const eform = this.entity.email.toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
              return eform
            }
          },
          checkEntity(){
            const card_data = localStorage.getItem('card_data')
            if(!this.entity.address || !this.entity.name || !this.entity.vatid ||
                !this.entity.regno || (this.nmonths < 1) || !this.checkEmailFormat()) {
              this.entityFlag = false
              localStorage.removeItem('invoice_data')
            }else{
              this.entityFlag = card_data
              localStorage.setItem('invoice_data','1')
            }
          },
          getInvoiceObject() {
            return {
              address: this.entity.address,
              name: this.entity.name,
              email: this.entity.email
            }
          },
          submitBuyerInfo(){
            /* set payment ongoing */
            this.payon = true
            /* clean  data of procedure that enable pay button*/
            this.cleanPayHandler()
            /* Request token from Stripe Server*/
            this.stripe.createToken(this.card).then( (result) => {
              /* start the payment then disable pay button*/
              this.entityFlag = false
              this.stripeClientTokenId = result.token.id
              //console.log('Stripe payment client token id:', result.token.id)
              /*send data to backend to get secret token of transaction : email & tokenValue & StripeAPI */
              const amount = this.price_unit*this.nmonths
              const baseURL = getBaseURL()
              /* add basic authentication of request*/
              const auth = get_UPAYS_auth()
              let pay_info = {
                amount:amount,
                currency:this.entity.currency,
                app_stripe_api:this.entity.api,
                app_email:'dnan66@gmail.com',
                vat_id:this.entity.vatid,
                reg_number:this.entity.regno,
                csc:false
              }
              let status = '500'
              fetch(baseURL + '/payments/payintent',{
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                  'Authorization': `Basic ${auth}`,
                  'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(pay_info),
              }).then( rsp => {
                if(rsp.status === 401){
                  status = '401'
                }
                if(rsp.ok) {
                  return rsp.json()
                }else{
                  return rsp.json().then( body => {
                    // transfer error generated in backend to frontend
                    throw Error(body.error)
                  })
                }
              }).then( response => {
                const secret = response['stripe_secret']
                // console.log('Secret received...'+secret)
                // proceed to payment
                // get invoice data
                let invoiceObject = this.getInvoiceObject()
                this.stripe.confirmCardPayment(secret, {
                  payment_method: {
                    card: this.card,
                    billing_details: {
                      address: {
                        //city: 'tm',
                        //state: 'romania',
                        line1: invoiceObject.address,
                        //country: "RO",
                        //postal_code: 3333444
                      },
                      name: invoiceObject.name,
                      email: invoiceObject.email
                    }
                  }
                }).then(payrsp => {
                  //console.log('Stripe Card Payment response...')
                  if(payrsp.paymentIntent.status === "succeeded") {
                    this.msgPaymentCompleted()
                    /*  activate pay button and go to the return page */
                    /*
                    this.emitter.emit('payment', {'eventContent': 'ok'})
                    this.entityFlag = true
                    this.payon = false
                   */
                    //this.continueToWebSite()
                    /* update analytics on AWE platform*/
                    this.testAnalytics(pay_info.amount,pay_info.currency)
                  }
                }).catch(payerr => {
                  this.entityFlag = true
                  this.payon = false
                  //console.log('Stripe Card Payment error...',payerr.message)
                  alert('Stripe Card Payment ERROR response : \n' + payerr.message)
                })
              }).catch(() => {
                this.entityFlag = true
                this.payon = false
                if(status === '401'){
                  alert('Unauthorized Request!');
                  this.$router.push('/401')
                }else {
                  alert('Unexpected Server Error !');
                  this.$router.push('/500')
                }
              })
            }).catch(err =>{
              //console.log('Error when create Stripe Client token:', err.message)
              alert(err.message+ '\n ERROR when init Stripe Payment process')
            })
          },
        }
    }
</script>
<style scoped>

     .required:after {
         content:" *";
         color: lightpink;
     }
    .stripe-container {
        padding: 20px 20px;
        max-width: 100%;
        margin:20px 100px;
        background-color: black;
        color: white;
        border-radius: 10px;
    }

    input,
    .StripeElement {
        box-sizing: border-box;
        height: auto;
        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        padding: 8px 8px;
    }

    input:focus,
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 black;
        color: black;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .row {
        display: -ms-flexbox; /* IE10 */
        display: flex;
        -ms-flex-wrap: wrap; /* IE10 */
        flex-wrap: wrap;
        margin: 0 -16px;
    }
    .acenter {
      padding: 10px;
      width: 60%;
      height: 60%;
      /*margin-left: 20%;*/
      display: inline-block;
      margin-bottom: 20px;
    }
    .col-25 {
        -ms-flex: 35%; /* IE10 */
        flex: 35%;
    }
    .col-50 {
        -ms-flex: 50%; /* IE10 */
        flex: 50%;
    }
    .col-75 {
        -ms-flex: 75%; /* IE10 */
        flex: 75%;
    }
    .col-25,
    .col-50,
    .col-75 {
        padding: 0 16px;
    }
    label {
        margin-bottom: 10px;
        display: block;
        font-size: 13px;
        text-align: left;
        clear: both;
        float:left;
        font-weight: bold;
    }
    input[type=text] {
      width: 45vh;
      height: 10px;
      margin-bottom: 15px;
      padding: 15px 5px 15px 5px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background-color: white;
      float:right;
      font-size: 17px;

    }
    input[type=email] {
      width: 30vh;
      height: 10px;
      margin-bottom: 15px;
      padding: 15px 5px 15px 5px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background-color: white;
      float:right;
      font-size: 17px;
    }
    input[type=business] {
      width: 22vh;
      height: 15px;
      margin-bottom: 25px;
      padding: 15px 5px 15px 5px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background-color: white;
      float:right;
      font-size: 17px;
    }
    input[type=number] {
      width: 10vh;
      height: 10px;
      margin-bottom: 25px;
      padding: 12px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background-color: white;
      margin-left: 5px;
      float: right;
      font-size: 17px;
    }
    .icon-container {
        padding: 7px 0;
    }
    .btn {
        background-color: lightgreen;
        color: black;
        padding: 10px;
        margin: 10px 0;
        border: none;
        width: 28vh;
        border-radius: 5px;
        cursor: pointer;
        font-size: 15px;
    }
    .btn:hover {
        background-color: limegreen;
    }
    .btn:disabled {
        background-color: #aaaaaa;
    }
    .btncancel {
        background-color: darkred;
        color: white;
        padding: 10px;
        margin: 10px 10px 10px 10px;
        border: none;
        width: 28vh;
        border-radius: 5px;
        cursor: pointer;
        font-size: 15px;
    }
    .btncancel:hover {
        background-color: crimson;
    }
    a {
      color: #ffffff;
      text-decoration: none;
    }

    hr {
        border: 1px solid lightgrey;
    }
    .bankmsg {
      font-style: italic;
      font-size: 12px;
      margin-top: 5px;
    }

    /* Mark input boxes that gets an error on validation: */
    input.invalid {
        background-color: #ffdddd;
    }
    .valability {
      font-size: 14px;
      font-weight: bold;
      color: darkblue;
      background-color: lightgreen;
      padding: 5px 5px;
      float: right;
      border-radius: 5px;
    }
    .privacymsg {
        font-size: 15px;
        padding-top: 10px;
        text-align: center
    }
    select {
      padding: 5px 5px;
      float: right;
      margin-right: 40px;
      font-size: 15px;
      border-radius: 5px;
    }
    .testflag {
      padding: 10px 10px;
      background-color: yellow;
      color:black;
      font-size: 12px;
      float: right;
    }
    /* dialog that show generated key customer */
     .myd {
       background: black;
       border-radius: 20px;
       margin-top: 200px;
       opacity: 0.8;
       color: white;
       border-color: #fa755a;
       font-family: Dialog,serif;
     }
     .myd:hover {
       opacity: 1;
     }
     .myd button {
       background-color: lightgrey;
       padding: 10px 30px;
       border-radius: 10px;
       cursor: pointer;
       margin-top: 30px;
     }
     .myd button:hover {
       background-color: white;
     }
     .myd div {
       margin-top: 10px;
     }
     .clear {
       font-size: 11px;
       color: lightsalmon;
       opacity: 0.6;
       cursor: pointer;
       border: none;
       background-color: transparent;
       float: right;
     }
    /* Responsive layout - when the screen is less than 430px wide,
       make the two columns stack on top of each other instead of next to each other
    */
    @media (max-width: 1150px) {
        .stripe-container {
          margin: 0px;
          width: 92%;
        }
        .row {
            flex-direction: column-reverse;
        }
        .col-25 {
            margin-bottom: 20px;
        }
        button {
            font-size: 10px;
        }
        input[type=text],input[type=email],input[type=business] {
            font-size: 20px;
            width: 100%;
        }
        .icon-container {
            font-size: 10px;
        }
        .bankmsg {
            font-size: 8px;
        }
        .btn {
            font-size: 10px;
            width: 11vh;
        }
        .btncancel {
            font-size: 10px;
            width:11vh;
        }
        .privacymsg {
            font-size: 8px;
        }
        .acenter {
          width: auto;
          height: auto;
        }
        span {
          font-size: 10px;
        }
        select {
          margin-right: 0;
        }
    }
</style>